import {Box, Flex, P, Span} from 'exsportia-components'
import {DateTime} from 'luxon'
import {FC, useCallback} from 'react'

import {CycleToShow} from '../../../api/subscription-bookings/helpers'
import {formatPromoMoney} from '../../../components/promo-code-field/use-promo-text'
import {TranslatorScope} from '../../../locale/types'
import {CurrenciesEnum} from '../../../types/currencies'
import {ExsportiaIcon} from '../../../ui/components/exsportia-icon/exsportia-icon'
import {useLocale} from '../../../utils/i18n'

type Props = {
  rolling: boolean,
  cyclesLength: number
  currency: CurrenciesEnum
  openInvoicePdf: (_: CycleToShow['transactions'][number]) => void
  cycle: CycleToShow
}

const styleConfigBySubStatusPaid: {
  PAID: {
    color: 'success',
    label: TranslatorScope,
  },
  CREDITED: {
    color: 'error',
    label: TranslatorScope,
  },
} = {
  PAID: {
    color: 'success',
    label: 'paid',
  },
  CREDITED: {
    color: 'error',
    label: 'refunded',
  },
}


export const PaidInvoice: FC<Props> = ({
  rolling,
  cyclesLength,
  currency,
  openInvoicePdf,
  cycle: {price, payDate, elIndex, credited, transactions, promoDiscount}
}) => {
  const {l} = useLocale()
  const {label, color} = styleConfigBySubStatusPaid[credited ? 'CREDITED' : 'PAID']
  const payDateString = DateTime.fromMillis(payDate).toLocaleString(DateTime.DATE_MED)
  const handleOpenInvoicePdf = useCallback(() => openInvoicePdf(transactions[0]), [openInvoicePdf])
  // eslint-disable-next-line
  const canDownload = Boolean(transactions[0]?.transactionId && transactions[0]?.docType)
  return (
    <Flex
      flex={1}
      height={'40px'}
      cursor={canDownload ? 'pointer' : 'default'}
      onClick={handleOpenInvoicePdf}
      flexDirection={'row'}
      alignItems={'center'}
    >
      {
        canDownload
        && (
          <Box mr={'12px'}>
            <ExsportiaIcon icon={'download'} color={'iconSecondary'}/>
          </Box>
        )
      }
      <Flex
        flex={1}
        flexDirection={'row'}
        alignItems={'center'}
      >
        <P variant={'footnote'}>
          <Span>
            {payDateString}
          </Span>
          <Span>
            {` · ${elIndex}${rolling ? '' : ` / ${cyclesLength}`} · `}
          </Span>
          <Span
            color={color}
          >
            {l(label, {caseAction: 'capitalize'})}
          </Span>
          {
            Number(promoDiscount) > 0
            && (
              <Span>
                {` · ${l('promo_cycle_discount', {amount: formatPromoMoney(Number(promoDiscount), currency)})}`}
              </Span>
            )
          }
        </P>
      </Flex>
      <Span
        pl={'8'}
        variant={'body'}
        color={color}
      >
        {l(`${currency}_symbolic` as TranslatorScope, {value: price})}
      </Span>
    </Flex>
  )
}